module.exports = __webpack_public_path__ + "img/info.97fb2d0f.png";